import styled from '@emotion/styled'

export const CalendarSettingsPanel = styled.div`
  background-color: #fff ;
  border-radius: 2px;
  box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
  position: absolute;
  right: 24px;
  top: 72px;
  width:  400px;
`

export const SlidersSettingsWrapper = styled.div`
  -ms-flex-pack: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  display: flex;
  justify-content: center;
  padding: 6px;
`
